module.exports = __webpack_public_path__ + "static/media/Crystal.acdee4fa.gif";